"use client";

import createIcon from './util/createIcon';
export default createIcon('M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z', 'SubdirectoryArrowRight');